const SAFE_CODE = /^[A-Z][A-Z0-9_]{2,79}$/;
const SAFE_STAGE = /^[a-z][a-z0-9-]{0,79}$/;
const PROGRAMMATIC_REPORT_FAILURE_MESSAGES = Object.freeze({
    validation: 'Rapor girdisi doğrulanamadı. Filtreleri ve seçili kayıtları kontrol ederek raporu yeniden oluşturun.',
    unavailable: 'Raporlama hizmeti şu anda kullanılamıyor. Biraz sonra yeniden deneyebilirsiniz.',
    terminal: 'Rapor oluşturulamadı. Hata ayrıntılarını destek ekibiyle paylaşın.',
});

function parseJson(value) {
    if (typeof value !== 'string' || value.length > 8_192) return null;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}

function responsePayload(value) {
    const error = value?.Error ?? value;
    const response = error?.response ?? error?.original?.response ?? error?.originalError?.response;
    const jqXhr = error?.jqXHR;
    const payload = error?.details
        ?? response?.data
        ?? jqXhr?.responseJSON
        ?? parseJson(jqXhr?.responseText)
        ?? (typeof error?.data === 'object' ? error.data : parseJson(error?.data));
    return payload && typeof payload === 'object' ? payload : {};
}

export function normalizeProgrammaticReportFailure(value) {
    const error = value?.Error ?? value;
    const payload = responsePayload(value);
    const statusCandidate = payload.statusCode
        ?? payload.status
        ?? error?.statusCode
        ?? error?.status
        ?? error?.response?.status
        ?? error?.original?.response?.status
        ?? error?.originalError?.response?.status
        ?? error?.jqXHR?.status;
    const status = Number(statusCandidate);
    const codeCandidate = payload.code ?? error?.code;
    const stageCandidate = payload.stage ?? error?.stage;

    return {
        status: Number.isInteger(status) && status >= 400 && status <= 599 ? status : 500,
        code: SAFE_CODE.test(codeCandidate || '') ? codeCandidate : 'REPORT_GENERATION_FAILED',
        stage: SAFE_STAGE.test(stageCandidate || '') ? stageCandidate : null,
        retryable: typeof payload.retryable === 'boolean'
            ? payload.retryable
            : error?.retryable === true,
    };
}

export function isProgrammaticReportFailure(failure) {
    return Boolean(failure?.stage)
        || /^(PROGRAMMATIC_REPORT_|REPORTING_INTERNAL_|REPORT_MODULE_)/.test(failure?.code || '');
}

export function canRetryProgrammaticReportFailure(failure) {
    return failure?.retryable === true;
}

export function programmaticReportFailureMessageKey(failure) {
    if (failure?.status === 422) return 'validation';
    if (failure?.status === 503 || failure?.status === 504 || failure?.retryable) return 'unavailable';
    return 'terminal';
}

export function programmaticReportFailureDefaultMessage(messageKey) {
    return PROGRAMMATIC_REPORT_FAILURE_MESSAGES[messageKey]
        ?? PROGRAMMATIC_REPORT_FAILURE_MESSAGES.terminal;
}
